import React from 'react'

import type { ReactElement, SVGProps } from 'react'

export type IconGeneratorComponentProp = (
  props: SVGProps<SVGSVGElement>
) => ReactElement

export type IconGeneratorProps = SVGProps<SVGSVGElement> & {
  iconComponent: IconGeneratorComponentProp
  size?: number | string
  rotationDegrees?: number
}

export const IconGenerator = ({
  iconComponent: IconComponent,
  width,
  height,
  size,
  rotationDegrees = 0,
  ...restOfProps
}: IconGeneratorProps) => {
  if (!IconComponent) {
    return null
  }

  return (
    <IconComponent
      width={size ?? width}
      height={size ?? height}
      aria-hidden="true"
      focusable="false"
      style={{ transform: `rotate(${rotationDegrees}deg)` }}
      {...restOfProps}
    />
  )
}
